import { HallowABFlag } from "./HallowABFlag.enum";

export const MixpanelABFlagValidProps = {
  [HallowABFlag.FamilyPlanOneClickUpgrade]: "family_plan_upgrade_valid",
} as const;
